<div class="export-modal">
  <div class="modal-header ps-24px">
    <div class="export-modal-header">
      <h5>{{translate?.general.buttons.move.singular}} {{selectedReportName}} {{translate?.report.messages.fromLower}} {{currentFolder}}</h5>
    </div>

    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="modalRef.hide();"
      [pTooltip]="translate?.general.buttons.close.singular"
      tooltipPosition="left"
    >
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  <form>
    <div class="modal-body pt-0">
      <!-- Destination label -->
      <div class="dest-title mb-2 prev" *ngIf="previousFolder" [hidden]="selectedFolder">
        <button class="back-btn" [hidden]="firstScreen" [pTooltip]="translate?.general.buttons.back.singular">
          <i class="fa-regular fa-arrow-left" aria-hidden="true" (click)="goBackOneFolderAbove()"></i>
        </button>
        <span class="title" [ngClass]="{'ps-12px': firstScreen}">{{translate?.report.messages.toCaps}}: {{ previousFolder.name }}</span>
      </div>

      <div class="dest-title mb-2 sel" *ngIf="selectedFolder">
        <button class="back-btn" [hidden]="firstScreen" [pTooltip]="translate?.general.buttons.back.singular">
          <i class="fa-regular fa-arrow-left" aria-hidden="true" (click)="goBackOneFolderAbove()"></i>
        </button>
        <span class="title" [ngClass]="{'ps-12px': firstScreen}">{{translate?.report.messages.toCaps}}: {{ selectedFolder.name }}</span>
      </div>

      <!-- Folder list (PrimeNG table rendered like a list) -->
      <p-table
        [value]="folders"
        selectionMode="single"
        [(selection)]="selectedFolder"
        dataKey="id"
        [styleClass]="'folder-table'"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{translate?.report.fields.name.singular}}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row" (click)="onFolderClick(row)" [pSelectableRowDisabled]="isRowDisabled(row)">
            <td class="folder-cell">
              <span class="folder-name">{{ row.name }}</span>
              <i class="fa fa-angle-right chev" aria-hidden="true" *ngIf="row.children?.length > 0"></i>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="modal-footer">
      <button type="button" class="custella-btn-white" (click)="modalRef.hide()">
        {{translate?.general.buttons.cancel.singular}}
      </button>
      <p-button
        [label]="translate?.general.buttons.move.singular"
        styleClass="h-32"
        [disabled]="!selectedFolder && firstScreen"
        (onClick)="onMoveSave()"
      >
      </p-button>
    </div>
  </form>
</div>
